import api from './axios';

export interface AlertConfig {
  enabled: boolean;
}

export const toggleAlerts = async (enabled: boolean): Promise<any> => {
  try {
    const response = await api.post('/config/alerts/toggle', { enabled });
    return response.data;
  } catch (error) {
    console.error('Error toggling alerts:', error);
    throw error;
  }
};

export const getAlertConfig = async (): Promise<AlertConfig> => {
  try {
    const response = await api.get('/config/type/alerts');
    const alertConfig = response.data.find((config: any) => config.key === 'alerts_enabled');
    return {
      enabled: alertConfig ? alertConfig.value : true, // Default to enabled if no config found
    };
  } catch (error) {
    console.error('Error getting alert config:', error);
    return { enabled: true }; // Default to enabled on error
  }
}; 